import { render, staticRenderFns } from "./personalInformation.vue?vue&type=template&id=0f88b558&scoped=true"
import script from "./personalInformation.vue?vue&type=script&lang=js"
export * from "./personalInformation.vue?vue&type=script&lang=js"
import style0 from "./personalInformation.vue?vue&type=style&index=0&id=0f88b558&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88b558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f88b558')) {
      api.createRecord('0f88b558', component.options)
    } else {
      api.reload('0f88b558', component.options)
    }
    module.hot.accept("./personalInformation.vue?vue&type=template&id=0f88b558&scoped=true", function () {
      api.rerender('0f88b558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myBoardChild/personalInformation.vue"
export default component.exports